import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import Hero from './components/Hero';
import ReviewHelper from './components/ReviewHelper';
import PlatformCards from './components/PlatformCards';
import WhatToMention from './components/WhatToMention';
import PrivateFeedback from './components/PrivateFeedback';
import Footer from './components/Footer';
import TileDivider from './components/TileDivider';

function App() {
  const platformsRef = useRef(null);

  const scrollToPlatforms = () => {
    platformsRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="min-h-screen bg-padua-ivory bg-tile-pattern font-sans relative overflow-hidden">
      {/* Subtle top gradient for warmth */}
      <div className="absolute top-0 left-0 right-0 h-[800px] bg-gradient-to-b from-padua-gold/10 via-padua-ivory to-transparent pointer-events-none"></div>

      <main className="relative z-10 flex flex-col items-center max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-24 space-y-24 md:space-y-32">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="w-full"
        >
          <Hero />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="w-full"
        >
          <ReviewHelper onCopy={scrollToPlatforms} />
        </motion.div>

        <TileDivider className="opacity-50" />

        <div ref={platformsRef} className="w-full scroll-mt-20">
          <PlatformCards />
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="w-full"
        >
          <WhatToMention />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="w-full"
        >
          <PrivateFeedback />
        </motion.div>

        {/* Mobile Sticky CTA - Scoped inside #root */}
        <motion.div
          initial={{ y: 100 }}
          animate={{ y: 0 }}
          className="fixed bottom-6 left-6 right-6 z-40 md:hidden"
        >
          <button
            onClick={scrollToPlatforms}
            className="w-full bg-padua-olive text-white py-4 rounded-full shadow-2xl font-medium tracking-wide border border-white/10 backdrop-blur-md"
          >
            Choose Review Platform
          </button>
        </motion.div>
      </main>

      <Footer />
    </div>
  );
}

export default App;